// Shim for setInterval, setTimeout, etc. not being
// supported in server-rendered JavaScript
// https://gist.github.com/assertchris/927843/cb71a7f5723976a437b3f0f7a64f52dc7e0f00e3

import { isSSR } from '@helpers';

if (isSSR()) {
  setTimeout = setTimeout || global.setTimeout;
  clearTimeout = clearTimeout || global.clearTimeout;
  setInterval = setInterval || global.setInterval;
  clearInterval = clearInterval || global.clearInterval;

  const objects = [];

  function getTime() {
    return +new Date();
  }

  function setObject(type, callback, delay) {
    const id = objects.length;

    objects.push({
      callback: callback,
      time: getTime(),
      delay: delay,
      type: type,
      id: id
    });
    return id;
  }

  function clearObject(id) {
    var i = objects.length;
    while (i--) {
      if (objects[i].id === id) {
        objects.splice(i, 1);
      }
    }
  }

  function setTimeout(callback, delay) {
    return setObject('timeout', callback, delay);
  }

  function setInterval(callback, delay) {
    return setObject('interval', callback, delay);
  }

  function clearTimeout(id) {
    clearObject.call(global, id);
  }

  function clearInterval(id) {
    clearObject.call(global, id);
  }

  global.setTimeout = setTimeout;
  global.clearTimeout = clearTimeout;
  global.setInterval = setInterval;
  global.clearInterval = clearInterval;
}
